import { CombinedManualAdjustmentType, FormType } from '@aloft/toolkit-shared';

export function isValidAdjForFormType(
  adj: CombinedManualAdjustmentType,
  formType?: FormType,
): boolean {
  switch (adj) {
    case 'foundation':
      return formType === FormType.fnma1004c;
    case 'units':
      return formType === FormType.fnma1025;
    default:
      return true;
  }
}
